/* remove https://test.wro-v.com before build */
// export const API = `/national_organizer/`;
// export const API = `https://arab01.wro-v.com/national_organizer/`;
// export const WRO = `https://wro-v.com/backend/`

// export const API = `https://greece.wro-v.local/`;
// export const WRO = `https://wro-v.local/`

// Local
// export const API = `https://majmaah.01skills.com/national_organizer/`;
// export const WRO = `https://server1.01skills.com/backend/`

// Live
// export const API = `http://localhost:8000/`;
export const API = `https://saudi.wro-v.com/national_organizer/`;
export const WRO = `https://wro-v.com/backend/`

// Sudan
// export const API = `https://sudan.wro-v.com/national_organizer/`;
// export const WRO = `https://wro-v.com/backend/`
